const dataItem = [
  {
    id: 0,
    title: "Gần tôi",
    src: "https://food.grab.com/static/images/placeholder-restaurant-2by1.jpg",
  },
  {
    id: 1,
    title: "Siêu tiệc giảm 99K",
    src: "https://food.grab.com/static/images/placeholder-restaurant-2by1.jpg",
  },
  {
    id: 2,
    title: "Tuần lễ món cơm",
    src: "https://food.grab.com/static/images/placeholder-restaurant-2by1.jpg",
  },
  {
    id: 3,
    title: "Quán ngon đặc tuyển",
    src: "https://food.grab.com/static/images/placeholder-restaurant-2by1.jpg",
  },
  {
    id: 4,
    title: "Tạp hóa online",
    src: "https://food.grab.com/static/images/placeholder-restaurant-2by1.jpg",
  },
  {
    id: 5,
    title: "5 ưu đãi cùng 1 đơn",
    src: "https://food.grab.com/static/images/placeholder-restaurant-2by1.jpg",
  },
];
export default dataItem;
